import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ConsentGate from './components/layout/ConsentGate';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConsentGate />
    <App />
  </React.StrictMode>
);